import { create } from 'zustand';

/** 'hard' = below minVersion → must update (blocking). 'soft' = below
 *  latestVersion → dismissible nudge. 'none' = up to date / not checked. */
export type UpdateGate = 'none' | 'soft' | 'hard';

interface UpdateState {
  gate: UpdateGate;
  setGate: (g: UpdateGate) => void;
  /** Dismiss the soft nudge for this session (hard can't be dismissed). */
  dismissSoft: () => void;
}

export const useUpdateStore = create<UpdateState>((set) => ({
  gate: 'none',
  setGate: (gate) => set({ gate }),
  dismissSoft: () => set((s) => (s.gate === 'soft' ? { gate: 'none' } : s)),
}));
